var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"classification"},_vm._l((_vm.imageList),function(item,index){return _c('a',{key:index,staticClass:"classification-item",attrs:{"href":item.path}},[_c('div',{staticClass:"classification-itemImg"},[_c('img',{attrs:{"src":item.typeLogo,"alt":""}})]),_c('p',{staticClass:"classification-text"},[_vm._v(_vm._s(item.type))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }